type StepDefinition = {
  index: 1 | 2 | 3 | 4 | 5;
  label: string;
  href: string;
  prerequisiteHint: string;
};

const STEPS: StepDefinition[] = [
  { index: 1, label: 'Choose Scenario', href: '#scenario-library', prerequisiteHint: 'Upload a capture first' },
  { index: 2, label: 'Add Event Marker', href: '#event-marker', prerequisiteHint: 'Choose a scenario first' },
  { index: 3, label: 'Run Correlation', href: '#event-correlation', prerequisiteHint: 'Add an event marker first' },
  { index: 4, label: 'Create Signal', href: '#correlation-results', prerequisiteHint: 'Run correlation first' },
  { index: 5, label: 'Export', href: '#correlation-results', prerequisiteHint: 'Create a signal first' }
];

type WorkspaceStepperProps = {
  currentStep: 1 | 2 | 3 | 4 | 5;
  unlockedThrough: 1 | 2 | 3 | 4 | 5;
};

type StepStatus = 'completed' | 'current' | 'pending' | 'locked';

function deriveStatus(stepIndex: number, currentStep: number, unlockedThrough: number): StepStatus {
  if (stepIndex < currentStep) return 'completed';
  if (stepIndex === currentStep) return 'current';
  if (stepIndex <= unlockedThrough) return 'pending';
  return 'locked';
}

export function WorkspaceStepper({ currentStep, unlockedThrough }: WorkspaceStepperProps) {
  return (
    <nav className="workspace-stepper" aria-label="Signal discovery workflow steps">
      <ol>
        {STEPS.map((step) => {
          const status = deriveStatus(step.index, currentStep, unlockedThrough);
          const numText = status === 'completed' ? '✓' : String(step.index);
          const className = `workspace-step workspace-step-${status}`;
          const ariaCurrent = status === 'current' ? 'step' : undefined;

          const inner = (
            <>
              <span className="workspace-step-num" aria-hidden="true">{numText}</span>
              <span className="workspace-step-label">{step.label}</span>
            </>
          );

          if (status === 'locked') {
            return (
              <li className={className} key={step.index}>
                <span
                  aria-disabled="true"
                  title={step.prerequisiteHint}
                  aria-label={`${step.label} — ${step.prerequisiteHint}`}
                >
                  {inner}
                </span>
              </li>
            );
          }

          return (
            <li className={className} key={step.index}>
              <a href={step.href} aria-current={ariaCurrent}>{inner}</a>
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
